import { PostHogProvider } from '@posthog/react';
import React from 'react';

import { POSTHOG_API_KEY, POSTHOG_BASE_URL } from '../constants';
import { usePostHogInit } from '../hooks/PostHogAnalytics';

const INIT_DEFAULT_OPTIONS = {
  api_host: POSTHOG_BASE_URL,
  defaults: '2026-01-30',
  persistence: 'cookie',
  opt_out_capturing_by_default: true,
} as const;

const PostHogInitializer = ({ children }: { children: React.ReactNode }) => {
  usePostHogInit();
  return <>{children}</>;
};

export const AnalyticsProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <PostHogProvider apiKey={POSTHOG_API_KEY} options={INIT_DEFAULT_OPTIONS}>
      <PostHogInitializer>{children}</PostHogInitializer>
    </PostHogProvider>
  );
};
